import styled from 'styled-components'

export const DivContainer = styled.div`
  width: fit-content;
`
